import React from 'react'
import ErrorIcon from '../../assets/svgs/close-circled.svg'
import Button from '../Button'
import PropTypes from "prop-types";

import './defaultDialogLayout.scss'

/** Default layout of a modal  */
const DefaultDialogLayout = ({title, buttonsArr, className, children, errorMessage}) => {
  return <div className={`Suc-default-dialog-layout ${className}`}>
    <span className='Suc-header'>{title}</span>
    <div className='Suc-dialog-content'>{children}</div>
    <div className='Suc-dialog-footer'>
      {errorMessage && <div className='Suc-error-message'>
        <div className='Suc-error-icon'><ErrorIcon/></div>
        <div className='Suc-error-text'>{errorMessage}</div>
      </div>}
      <div className='Suc-buttons-container'>
        {buttonsArr?.map(({text, className, ...rest}) => <Button
          key={text}
          className={`Suc-dialog-button ${className}`} {...rest}
        >{text}
        </Button>)}
      </div>
    </div>
  </div>
}

DefaultDialogLayout.propTypes = {
  /** title of the dialog */
  title: PropTypes.node,
  /** Array of Buttons in the modal footer */
  buttonsArr: PropTypes.array,
  /** custom className */
  className: PropTypes.string,
  /** modal content */
  children: PropTypes.node,
  /** error message, null for no error message */
  errorMessage: PropTypes.string,
}

DefaultDialogLayout.defaultProps = {
  errorMessage: null,
  className: ''
};

export default DefaultDialogLayout
